/**
 * @fileoverview Bridge PrimeReact actions to the application's managed icon vocabulary. `AppIcon.js` owns icon resolution while PrimeReact retains button behavior. Callers own action execution and pending/disabled state; `AppButton.js` is the native-button alternative.
 */

import React from 'react';
import { Button as PrimeButton } from 'primereact/button';
import AppIcon from './AppIcon';



function resolveButtonIcon(icon, options = {}) {
  if (!icon || React.isValidElement(icon)) {
    return icon;
  }

  if (typeof icon === 'string') {
    return <AppIcon icon={icon} spin={options.spin} />;
  }

  return icon;
}



function AppPrimeButton({ icon, loadingIcon, ...rest }) {
  return (
    <PrimeButton
      {...rest}
      icon={resolveButtonIcon(icon)}
      loadingIcon={resolveButtonIcon(loadingIcon || 'pi pi-spin pi-spinner', { spin: true })}
    />
  );
}

export default AppPrimeButton;
